import { render, staticRenderFns } from "./SalonsFormComponent.vue?vue&type=template&id=0fc919c3&"
import script from "./SalonsFormComponent.vue?vue&type=script&lang=js&"
export * from "./SalonsFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports